new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        // Showcase
        showOpened: false,
        expandDesc: false,
        installmentOpened: false,
        //Thumb
        imgSrc: '',
        imgTitle: '',
        isVideo: ''
    },
    methods: {
        updateImage(src) {
            if (!this.showOpened)
                this.showOpened = true;
            this.imgSrc = src;
            this.isVideo = false;
        },

        updateVideo(src) {
            if (!this.showOpened)
                this.showOpened = true;
            this.imgSrc = false;
            this.isVideo = src;
        },

        setThumbHeight() {
            return document.querySelector('.product-detail__header--photoArea-thumbs').style.height = document.querySelector('#photo-list li.visible').clientHeight * this.slidesToShow + 'px;';
        },

        handleESC(event) {
            if (event.key === 'Escape')
                this.showOpened = false
        },

        checkBuyView() {
            const buyButton = document.getElementById("buy-button");
            const rect = buyButton.getBoundingClientRect();

            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                const otherElements = document.querySelectorAll(".product-detail__fixed--buy, .fixed-buy-product");
                otherElements.forEach(function(element) {
                    element.classList.remove("active");
                });
            } else {
                const otherElements = document.querySelectorAll(".product-detail__fixed--buy, .fixed-buy-product");
                otherElements.forEach(function(element) {
                    element.classList.add("active");
                });
            }
        },

        moveToBuy() {
            var productSize = document.getElementById("product-size");
            if (productSize) {
                productSize.scrollIntoView({ behavior: "smooth" });
            }
        }
    },
    created() {
        const label = document.querySelector('.product-detail__header .product-detail__header--infoArea .product-detail__header--infoArea-kit .label_attributes');
        const size = document.querySelector('.product-detail__size-guide');
        if (label && size) {
            label.append(size)
        }
    },
    mounted() {
        this.checkBuyView();
        window.addEventListener("scroll", this.checkBuyView, { passive: true });

        const detailOptions = document.querySelector('.product-detail__header--infoArea-kit .product-radio-variation');
        if (detailOptions) {
            let cloneDetailOptions = detailOptions.cloneNode(true);
            let optionsFixedProduct = document.querySelector('.fixed-buy-product .apeend-options');
            optionsFixedProduct?.append(cloneDetailOptions);

            let options = detailOptions.querySelectorAll('label');
            if (options.length) {
                options.forEach((item) => {
                    item.addEventListener('click', () => {
                        options.forEach(opt => opt.classList.remove('active'));
                        item.classList.add('active');
                    })
                });
            }
        }

        let description = document.querySelector('.description-nav');
        if (description) {
            let navTab = description.querySelectorAll('.nav-item');
            let navShow = description.querySelectorAll('.description-nav-content');
            navTab = Array.from(navTab);
            navShow = Array.from(navShow);

            if (navTab.length && navShow.length) {
                function toggleTab(index) {
                    const isActive = navTab[index].classList.contains('active');

                    // remove todas as classes active
                    navTab.forEach((content) => content.classList.remove('active'));
                    navShow.forEach((content) => content.classList.remove('active'));

                    // se não estava ativo, ativa
                    if (!isActive) {
                        navTab[index].classList.add('active');
                        navShow[index].classList.add('active');
                    }
                }

                navTab.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', () => {
                        toggleTab(index);
                    });
                });
            }
        }

        if (window.matchMedia("(min-width: 992px)").matches) {
            if ($('.product-rating__review-list')) {
                $('.product-rating__review-list').slick({
                    swipeToSlide: true,
                    touchThreshold: 100,
                    arrows: true,
                    dots: false,
                    infinite: false,
                    mobileFirst: true,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    speed: 100,
                });
            }
        }

        const photoList = document.getElementById("photo-list");
        if (photoList) {
            const firstLi = photoList.querySelector("li");
            if (firstLi) {
                const imgElement = firstLi.querySelector("img");

                if (imgElement) {
                    this.imgSrc = imgElement.getAttribute("src");
                    this.imgTitle = imgElement.getAttribute("title");
                }
            }
        }

        const userLetterElement = document.getElementById('user_letter');
        if (userLetterElement) {
            const userLetter = userLetterElement.innerText.trim();
            if (userLetter.length > 0) {
                userLetterElement.innerText = userLetter[0];
            }
        }

        document.addEventListener('keydown', this.handleESC, { passive: true });
        window.addEventListener("scroll", this.checkBuyView, { passive: true });
        window.addEventListener("load", this.checkBuyView, { passive: true });
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleESC);
    },
    watch: {
        showOpened(newValue) {
            if (newValue) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.removeProperty('overflow');
            }
        },
    }
})

$(document).ready(function () {

    waitForElementToExist('#js_buy_together_api_layout_1_groups').then(element => {
        // Controle de seleção dos tamanhos nos grupos (2 a 3 Uls possíveis)
        const ADD_CART_BTN_SELECTOR = '#js_buy_together_api_add_cart';
        const GROUP_IDS = ['#js_buy_together_api_group_0', '#js_buy_together_api_group_1', '#js_buy_together_api_group_2'];

        const getGroups = () => GROUP_IDS
            .map(sel => document.querySelector(sel))
            .filter(Boolean);

        const isAllowSelectProducts = () => {
            const buyTogetherApi = document.querySelector('.buy-together-api');
            return buyTogetherApi && buyTogetherApi.classList.contains('allow-select-products');
        };

        const getGroupsToCheck = () => {
            const allGroups = getGroups();
            
            // Se tiver .allow-select-products, filtra apenas grupos com checkbox marcado
            if (isAllowSelectProducts()) {
                return allGroups.filter(group => {
                    // Procura checkbox dentro do grupo
                    const checkbox = group.querySelector('.checkbox-together-selectable');
                    return checkbox && checkbox.checked;
                });
            }
            
            // Caso contrário, retorna todos os grupos
            return allGroups;
        };

        const isGroupSelected = (group) => {
            if (!group) return false;
            const options = group.querySelector('.product-item__options');
            if (!options) return false;

            // Seleção via select
            const select = options.querySelector('select');
            if (select) {
                const val = select.value;
                return val !== '' && val !== undefined && val !== null && val !== '0';
            }

            // Seleção via inputs (ex: radio)
            const radios = options.querySelectorAll('input[type="radio"]');
            if (radios.length) {
                return Array.from(radios).some(r => r.checked);
            }

            const checkboxes = options.querySelectorAll('input[type="checkbox"]');
            if (checkboxes.length) {
                return Array.from(checkboxes).some(c => c.checked);
            }

            // Outros inputs (fallback): considera preenchido se houver value não vazio
            const inputs = options.querySelectorAll('input');
            if (inputs.length) {
                return Array.from(inputs).some(i => (i.type !== 'radio' && i.type !== 'checkbox') && i.value && String(i.value).trim() !== '');
            }

            return false;
        };

        const updateUI = () => {
            const allGroups = getGroups();
            const groupsToCheck = getGroupsToCheck();
            const addCartBtn = document.querySelector(ADD_CART_BTN_SELECTOR);
            if (!allGroups.length || !addCartBtn) return;

            // Atualiza classe please-select por grupo (todos os grupos)
            allGroups.forEach(group => {
                const selected = isGroupSelected(group);
                group.classList.toggle('please-select', !selected);
            });

            // Regra: liberar compra quando TODOS os grupos a verificar tiverem seleção
            // Se tiver .allow-select-products, só verifica grupos com checkbox marcado
            // Caso contrário, verifica todos os grupos presentes
            const allSelected = groupsToCheck.length > 0 && groupsToCheck.every(g => isGroupSelected(g));
            addCartBtn.classList.toggle('no-buy', !allSelected);
        };

        const bindEvents = () => {
            const container = document.querySelector('#js_buy_together_api_layout_1_groups');
            const buyTogetherApi = document.querySelector('.buy-together-api');
            if (!container) return;

            // Delegação para mudanças em selects e inputs dentro dos grupos
            container.addEventListener('change', (e) => {
                const target = e.target;
                if (!(target instanceof Element)) return;
                // Verifica mudanças nos grupos ou nos checkboxes de seleção
                if (target.closest('#js_buy_together_api_group_0, #js_buy_together_api_group_1, #js_buy_together_api_group_2') ||
                    target.classList.contains('checkbox-together-selectable')) {
                    updateUI();
                }
            }, { passive: true });

            // Alguns temas usam click para marcar radios customizados
            container.addEventListener('click', (e) => {
                const target = e.target;
                if (!(target instanceof Element)) return;
                // Verifica cliques nos grupos ou nos checkboxes de seleção
                if (target.closest('#js_buy_together_api_group_0, #js_buy_together_api_group_1, #js_buy_together_api_group_2') ||
                    target.classList.contains('checkbox-together-selectable') ||
                    target.closest('.checkbox-together-selectable')) {
                    // pequeno defer para permitir atualização de checked
                    setTimeout(updateUI, 0);
                }
            }, { passive: true });

            // Se tiver .allow-select-products, adiciona listeners específicos para os checkboxes
            if (buyTogetherApi && buyTogetherApi.classList.contains('allow-select-products')) {
                // Event listener no buy-together-api para capturar checkboxes que podem estar fora do container
                // Usa delegação de eventos para capturar checkboxes adicionados dinamicamente
                const handleCheckboxChange = (e) => {
                    const target = e.target;
                    if (target && (target.classList.contains('checkbox-together-selectable') || 
                        target.closest('.checkbox-together-selectable'))) {
                        updateUI();
                    }
                };

                const handleCheckboxClick = (e) => {
                    const target = e.target;
                    if (target && (target.classList.contains('checkbox-together-selectable') || 
                        target.closest('.checkbox-together-selectable'))) {
                        // pequeno defer para permitir atualização de checked
                        setTimeout(updateUI, 10);
                    }
                };

                buyTogetherApi.addEventListener('change', handleCheckboxChange, { passive: true });
                buyTogetherApi.addEventListener('click', handleCheckboxClick, { passive: true });

                // Também adiciona listener no documento para garantir que capture todas as mudanças
                // mesmo que o checkbox seja adicionado dinamicamente em outro lugar
                document.addEventListener('change', (e) => {
                    const target = e.target;
                    if (target && target.classList.contains('checkbox-together-selectable') &&
                        buyTogetherApi.contains(target)) {
                        updateUI();
                    }
                }, { passive: true });

                document.addEventListener('click', (e) => {
                    const target = e.target;
                    if (target && (target.classList.contains('checkbox-together-selectable') ||
                        target.closest('.checkbox-together-selectable')) &&
                        buyTogetherApi.contains(target.closest('.checkbox-together-selectable') || target)) {
                        setTimeout(updateUI, 10);
                    }
                }, { passive: true });

                // Observa mudanças de atributos (checked) nos checkboxes
                const checkboxObserver = new MutationObserver((mutations) => {
                    let shouldUpdate = false;
                    mutations.forEach((mutation) => {
                        if (mutation.type === 'attributes' && 
                            (mutation.attributeName === 'checked' || mutation.attributeName === 'class')) {
                            shouldUpdate = true;
                        }
                    });
                    if (shouldUpdate) {
                        updateUI();
                    }
                });

                // Observa todos os checkboxes existentes e futuros
                const observeCheckboxes = () => {
                    const checkboxes = buyTogetherApi.querySelectorAll('.checkbox-together-selectable');
                    checkboxes.forEach(checkbox => {
                        checkboxObserver.observe(checkbox, { 
                            attributes: true, 
                            attributeFilter: ['checked', 'class'] 
                        });
                    });
                };

                // Observa adição de novos checkboxes e mudanças no DOM
                const checkboxContainerObserver = new MutationObserver((mutations) => {
                    let shouldObserve = false;
                    mutations.forEach((mutation) => {
                        if (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0) {
                            shouldObserve = true;
                        }
                    });
                    if (shouldObserve) {
                        observeCheckboxes();
                        // Pequeno delay para garantir que o DOM foi atualizado
                        setTimeout(updateUI, 10);
                    }
                });
                checkboxContainerObserver.observe(buyTogetherApi, { 
                    childList: true, 
                    subtree: true,
                    attributes: false
                });
                
                // Inicializa observação dos checkboxes existentes
                observeCheckboxes();
            }

            // Observa mudanças dinâmicas (ex: render async dos grupos)
            const observer = new MutationObserver(() => {
                updateUI();
            });
            observer.observe(container, { childList: true, subtree: true });
        };

        bindEvents();
        // Inicializa estado
        updateUI();
    });

    $('.product-detail__header--photoArea-mobile').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: true,
        mobileFirst: true,
        speed: 700,
        vertical: false,
    })

    $('#photo-list').slick({
        slidesToShow: 4,
        arrows: true,
        dots: false,
        infinite: false,
        mobileFirst: false,
        speed: 700,
        vertical: true,
        appendArrows: ".product-detail__showcase--controls-slick",
    })

    $('#like-carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        speed: 700,
        vertical: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 5,
                    arrows: true
                }
            },
        ]
    })

    // if (window.matchMedia("(min-width: 992px)").matches) {
    //     function animeScroll() {
    //         const photoScroll = document.querySelector('.product-detail__header--photoArea');
    //         const sidebarInner = document.querySelector('.sidebar__inner');

    //         if (photoScroll && sidebarInner && photoScroll.offsetHeight > sidebarInner.offsetHeight) {
    //             const containerWidth = $('.product-detail__header--infoArea').width();
    //             const sidebarInnerHeight = sidebarInner.offsetHeight;
    //             const totalHeight = photoScroll.offsetHeight - sidebarInnerHeight;
    //             const pageTop = window.pageYOffset;
    //             const rect = photoScroll.getBoundingClientRect();
    //             const offsetTop = rect.top + pageTop; // Calculate the distance from top of the page to the photoScroll

    //             if (pageTop > (offsetTop + totalHeight)) {
    //                 $('.sidebar__inner').css({ position: 'relative', top: totalHeight + 'px', maxWidth: '100%', paddingRight: '0' });
    //             } else if (pageTop > offsetTop) {
    //                 $('.sidebar__inner').css({ position: 'fixed', top: '0px', maxWidth: containerWidth + 'px', paddingRight: '40px' });
    //             } else {
    //                 $('.sidebar__inner').css({ position: 'relative', top: '0px', maxWidth: '100%', paddingRight: '0' });
    //                 $('.sidebar__inner').css({ paddingTop: '0' + 'px' });
    //             }
    //         }
    //     }

    //     window.addEventListener('scroll', function () {
    //         animeScroll();
    //     });

    //     animeScroll();
    // }

    waitForElementToExist('.custom-description--images').then(element => {
        $('.custom-description--images').slick({
            arrows: false,
            dots: true,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,

            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                }
            ]
        });
    });


    waitForElementToExist('.first-vitrine').then(element => {
        const firstCarrousel = element.querySelector('.product_list');
        if (firstCarrousel) {
            $('.product_list').slick({
                arrows: true,
                prevArrow: $(".count-1 .count-prev"),
                nextArrow: $(".count-1 .count-next"),
                dots: false,
                infinite: true,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 700,

                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('.product_list').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }

        /* Fix bug with slick on new product render (vitrine) */
        const elementosLazy = document.querySelectorAll('.lazy-img');

        elementosLazy.forEach(elemento => {
            const dataSrc = elemento.getAttribute('data-src');
            if (dataSrc) {
                elemento.setAttribute('src', dataSrc);
                elemento.removeAttribute('data-src');
            }
        });
    });

    const brinde = document.querySelector('.product-detail__brinde');

    if (brinde) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                const noBefore = widget.querySelector('.label-content');
                                if (noBefore) {
                                    widget.classList.add('no-before');
                                } else if (sizes) {
                                    widget.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                    });

                                    const allSizes = sizes.querySelectorAll('label');
                                    allSizes.forEach(size => {
                                        size.addEventListener('click', () => {
                                            sizes.classList.toggle('active');
                                            widget.setAttribute('data-before', size.textContent);
                                        });
                                    });
                                }
                            } else if (!sizes) {
                                widget.classList.add('no-before');
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                const noBefore = widget.querySelector('.label-content');
                                if (noBefore) {
                                    widget.classList.add('no-before');
                                } else if (sizes) {
                                    widget.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                    });

                                    const allSizes = sizes.querySelectorAll('label');
                                    allSizes.forEach(size => {
                                        size.addEventListener('click', () => {
                                            sizes.classList.toggle('active');
                                            widget.setAttribute('data-before', size.textContent);
                                        });
                                    });
                                }
                            } else if (!sizes) {
                                widget.classList.add('no-before');
                            }
                        }
                    }
                });
            });
        });

        observer.observe(brinde, {
            childList: true,
            subtree: true
        });

    }

    const buyTogether = document.querySelector('.product-detail__buy-together');

    if (buyTogether) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_0' || node.querySelector('#js_buy_together_api_group_0')) {
                            const targetNode = node.id === 'js_buy_together_api_group_0' ? node : node.querySelector('#js_buy_together_api_group_0');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('div[id^="js-product_price__product_detail_list_"]');

                            if (options && figcaption) {
                                figcaption.insertAdjacentElement('afterend', options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                    if (options) {
                                        options.classList.toggle('frente');
                                    }
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        if (options) {
                                            options.classList.toggle('frente');
                                        }
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            } else if (!sizes && widget) {
                                widget.classList.add('no-before')
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('div[id^="js-product_price__product_detail_list_"]');

                            if (options && figcaption) {
                                figcaption.insertAdjacentElement('afterend', options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            } else if (!sizes && widget) {
                                widget.classList.add('no-before')
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('div[id^="js-product_price__product_detail_list_"]');

                            if (options && figcaption) {
                                figcaption.insertAdjacentElement('afterend', options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            } else if (!sizes && widget) {
                                widget.classList.add('no-before')
                            }
                        }
                    }
                });
            });
        });

        observer.observe(buyTogether, {
            childList: true,
            subtree: true
        });

    }
})